export enum IconNames {
  FA_FAX = "FaFax",
  FA_PHONE = "FaPhone",
  FA_SEARCH = "FaSearch",
  FA_USER_MD = "FaUserMd",
  HI_OUTLINE_MAIL = "HiOutlineMail",
}
